// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","card":"Home_card__lxMQh"};